<div class="note-wrapper">
  <div
    #noteElement
    class="resident-note"
    [class.washy]="shouldBeWashy"
    [class.note-active]="isNoteActive"
    [class.hide-elements]="hideElements"
    (click)="openNoteModal()">
    <p>{{ resident.internalNote }}</p>
    <mat-icon
      svgIcon="edit-icon"
      class="edit-icon"
      *ngIf="permissionsService.canManageResidents()"></mat-icon>
  </div>
</div>
